import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apis } from '../config/api';

export interface PublicSchool {
  id: string;
  name: string;
  logo: string | null;
  currency: string;
}

export interface PublicPriceRow {
  id: string;
  levelId: string | null;
  durationUnit: number; // PRODUCT_DURATION_UNIT: 1=Hour 2=Day 3=Week 4=Minute
  durationValue: number;
  price: number | string;
  level?: { id: string; levelName: string; position?: number } | null;
}

export interface PublicProduct {
  id: string;
  title: string;
  publicDescription: string | null;
  publicImageUrl: string | null;
  displayOrder: number;
  currency: string;
  pax: number;
  activityId: string;
  modalityId: string;
  activity?: { id: string; name: string };
  modality?: { id: string; modalityName: string };
  levels?: { id: string; levelName: string; position?: number }[];
  prices?: PublicPriceRow[];
}

export interface PublicProductsResponse {
  school: PublicSchool;
  products: PublicProduct[];
}

export interface PublicBookingCustomer {
  firstName: string;
  lastName?: string;
  email: string;
  phone?: string | null;
  phonePrefix?: string | null;
}

// A booking is a request over a stay window; the school schedules the actual
// lessons later. Dates are date-only (YYYY-MM-DD); preferred time is optional.
export interface CreatePublicBookingPayload {
  productId: string;
  priceRowId: string;
  levelId?: string | null;
  arrivalDate: string; // YYYY-MM-DD
  departureDate: string; // YYYY-MM-DD
  preferredStartTime?: string | null; // HH:mm, or null = no preference
  customer: PublicBookingCustomer;
}

@Injectable({ providedIn: 'root' })
export class PublicBookingService {
  private http = inject(HttpClient);
  private url = apis.public;

  listProducts(schoolId: string): Observable<PublicProductsResponse> {
    return this.http.get<PublicProductsResponse>(`${this.url}/${schoolId}/products`);
  }

  createBooking(schoolId: string, payload: CreatePublicBookingPayload): Observable<any> {
    return this.http.post(`${this.url}/${schoolId}/bookings`, payload);
  }
}
